function gridpp() {
 $('.gridpp').each(function(){
  const $module = $(this);
  const $btnMore = $module.find('.gridpp--more');
  const $items = $module.find('.gridpp--item');
  let numItemsTotal = $items.length;
  let numItemsVisible = 6;
  let incrBy = 3;

  function more() {
   numItemsVisible = Math.min(numItemsTotal, numItemsVisible + incrBy);
   $items.slice(0, numItemsVisible).removeClass('-inactive');
   if (numItemsTotal <= numItemsVisible) {
    $module.find('.gridpp--morec').remove();
   }
   bus.emit('resizeContainer')
   bus.emit('revealRefresh')
   bus.emit('checkScrollReveal')
   bus.emit('scrollupdate')
  }

  function eventOn() {
   bus.on('pageLeaveEnd', eventOff);
   $btnMore.on('click', more);
  }

  function eventOff() {
   bus.off('pageLeaveEnd', eventOff);
   $btnMore.off('click', more);
  }

  eventOn();

  // AJOUT : Masquer initialement les items au-delà du nombre visible (6)
  // Cela suppose que TOUS les items ont initialement la classe '-inactive'
  // et que l'on veut en afficher 6 par défaut.
  $items.slice(0, numItemsVisible).removeClass('-inactive');
  $items.slice(numItemsVisible).addClass('-inactive'); // Si jamais ils n'ont pas la classe

 });
}
export default gridpp;